import React, { useEffect } from 'react';
import styles from './Jobs.module.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Meta from './Meta';

const jobsData = [
  {
    id: 1,
    title: 'Монтажник связи',
    requirements: 'Опыт монтажных работ, знание ПК, образование не ниже средне-специального, навыки работы с электроинструментом.',
    tasks: 'Подключение кабельного телевидения (монтаж коаксиального кабеля, обжим, установка кабель-каналов), подключение интернет (монтаж витой пары, установка активного оборудования), установка и настройка сетевой карты и роутеров.',
    contactPerson: 'Плотников Александр Евгеньевич',
    email: 'info@itosoba.ru',
    phone: '+7 (499) 103-31-48',
  },
  
];

export function Jobs() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true }); 
  }, []);

  return (
      <React.Fragment>
      <Meta
         title="Карьера в «ИТ Особа»: актуальные вакансии в телекоммуникационной компании"
         description="Присоединяйтесь к команде провайдера «ИТ Особа»!"
       />
    <div className={styles.jobsContainer}>
      <h2 className={styles.title} data-aos="fade-down">Вакансии:</h2>
      {jobsData.map(({ id, title, requirements, tasks, contactPerson, email, phone }) => (
        <div key={id} className={styles.jobCard} data-aos="fade-up" data-aos-delay={id * 100}>
          <h3 className={styles.jobTitle}>{title}</h3>
          <p><strong>Требования:</strong> {requirements}</p>
          <p><strong>Задачи:</strong> {tasks}</p>
          <p><strong>Контактное лицо:</strong> {contactPerson}</p>
          <p><strong>Адрес эл. почты:</strong> <a href={`mailto:${email}`} className={styles.emailLink}>{email}</a></p>
          <p><strong>Телефон:</strong> {phone}</p>
        </div>
      ))}
    </div>
    </React.Fragment>
  );
}